import React, { useEffect, useState } from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/site';
const AUTOPLAY_MS = 4000;
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return;
    const id = window.setInterval(() => setIndex(i => (i + 1) % testimonials.length), AUTOPLAY_MS);
    return () => window.clearInterval(id);
  }, [paused]);
  return <section id="testimonios" className="bg-forest-900 py-20 lg:py-28" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-id="element-274" data-mp="31ybhbjvz9rk8">
      <div className="mx-auto max-w-4xl px-5 lg:px-8" data-id="element-275" data-mp="2s2rvxrf1ib9q">
        <SectionHeading tone="dark" title="+500 familias ya invirtieron en su futuro" description="Clientes reales de Jutiapa, Chiquimula y la capital." data-id="element-276" data-mp="v9gahoeeu4po" />

        <div className="mt-14 overflow-hidden" aria-live="polite" data-id="element-277" data-mp="q8irxaphn8nn">
          <div className="flex transition-transform duration-300 ease-smooth" style={{
          transform: `translateX(-${index * 100}%)`
        }} data-id="element-278" data-mp="h4dewra7py6t">
            {testimonials.map(testimonial => <figure key={testimonial.nombre} className="w-full shrink-0 px-1" data-id="element-279" data-mp="79v3ezyk0ycg">
                <div className="rounded-sm bg-white p-8 sm:p-10" data-id="element-280" data-mp="c73r1g2h1ul3">
                  <div className="flex gap-0.5" aria-label={`${testimonial.estrellas} de 5 estrellas`} data-id="element-281" data-mp="zw68amt71lf2">
                    {Array.from({
                  length: testimonial.estrellas
                }).map((_, i) => <StarIcon key={i} size={16} className="fill-gold text-gold" data-id="element-282" data-mp="q7eiolblvd7b" data-mpi={i} />)}
                  </div>
                  <blockquote className="mt-5 font-display text-xl leading-snug text-forest-900 sm:text-2xl" data-id="element-283" data-mp="v44xl5boc2r5">
                    “{testimonial.comentario}”
                  </blockquote>
                  <figcaption className="mt-7 flex items-center gap-4" data-id="element-284" data-mp="1nn221ph7mqoy">
                    <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-forest-900 font-display text-lg text-gold-400" data-id="element-285" data-mp="1xiitozps5qka">
                      {testimonial.nombre.split(' ').slice(0, 2).map(part => part[0]).join('')}
                    </span>
                    <span data-id="element-286" data-mp="1jkkfbubglu4s">
                      <span className="block text-[14px] font-semibold text-forest-900" data-id="element-287" data-mp="1ejoejpmemo3l">
                        {testimonial.nombre}
                      </span>
                      <span className="block text-[12px] uppercase tracking-[0.12em] text-forest-900/55" data-id="element-288" data-mp="19qbqphpjulbw">
                        {testimonial.ciudad}
                      </span>
                    </span>
                  </figcaption>
                </div>
              </figure>)}
          </div>
        </div>

        <div className="mt-8 flex justify-center gap-2.5" data-id="element-289" data-mp="qtke1r4ij4gt">
          {testimonials.map((testimonial, i) => <button key={testimonial.nombre} type="button" onClick={() => setIndex(i)} aria-label={`Ver testimonio de ${testimonial.nombre}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-smooth ${i === index ? 'w-8 bg-gold' : 'w-2 bg-white/30 hover:bg-white/60'}`} data-id="element-290" data-mp="32hfcp5e39ods" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}